export default "__VITE_ASSET__DjsTnVFz__"